import { Component } from 'react';
import { Contribution } from '../../../../../../../common/model/input/contributions/types';
import { ModalOptions } from '../../../../../../untidy/redux/modules/modal';
import { aiName } from '../../../../../../untidy/texts';
import { TextField } from '../../../../../generic/components/inputs/text-field';
import { themeDEPRECATED } from '../../../../../generic/global/styles';
import { ContributionModalParagraph, ContributionModalTitle, FormRow } from './common';
import { FormButton } from './form-button';

interface State {
  comment?: string;
}

interface Props {
  isSubmitting: boolean;
  submitContribution: (options: { target?: string; data: Contribution }) => void;
  options: ModalOptions;
}

export class InvalidProductForm extends Component<Props, State> {
  public state: State = {};

  public render() {
    const {
      isSubmitting,
      options: { target, targetName, existingData },
    } = this.props;
    const { comment } = this.state;

    const productDescription = existingData && existingData.productDescription;

    if (!target || !targetName) {
      console.error(`Missing required metadata for form`);
      return null;
    }

    const canSubmit = !!comment;

    return (
      <>
        <ContributionModalTitle>
          Is {targetName ? targetName.toLowerCase() : 'this product'} a nonsensical product label?
        </ContributionModalTitle>
        <ContributionModalParagraph>
          If you think this product label is unclear or does not make sense, share it with {aiName}.
        </ContributionModalParagraph>
        <form
          onSubmit={e => {
            e.preventDefault();
          }}
        >
          <ContributionModalParagraph style={{ marginTop: themeDEPRECATED.rhythm(4) }}>
            <strong>Product:</strong> {targetName}
            <br />
            {productDescription && (
              <span>
                <strong>Description:</strong> This refers to {productDescription}
              </span>
            )}
          </ContributionModalParagraph>
          <FormRow>
            <TextField
              label={`How should ${aiName} improve her understanding about this product?`}
              id="comment"
              type="textarea"
              value={comment}
              disabled={isSubmitting}
              onChange={value => {
                this.setState({ comment: value });
              }}
            />
          </FormRow>
          <FormRow>
            <FormButton
              type="submit"
              disabled={isSubmitting || !canSubmit}
              onClick={() => {
                if (this.state.comment) {
                  this.props.submitContribution({
                    target,
                    data: {
                      type: 'PRODUCT_INVALID',
                      comment: this.state.comment,
                    },
                  });
                }
              }}
              style={{ width: '100%' }}
            >
              Submit
            </FormButton>
          </FormRow>
        </form>
      </>
    );
  }
}
